import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, NgModule, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

declare const $: any;

@Component({
  selector: 'progressbar',
  template: `<progress class="progress progress-{{state}}" value="{{value}}" max="{{max}}">{{ratio}}</progress>`,
})

export class ProgressbarComponent {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public value: number;
  @Input() public max: number;
  @Input() public ratio: any;
  @Input() public state: string;

  constructor() {
  }

  ngOnInit() {
    if (this.max != 0) {
      this.ratio = (100 * this.value / this.max).toFixed(0) + ' %';
    } else {
      this.ratio = '';
    }
  }
}
